<template>
  <v-container fluid class="pa-0">
    <v-card>
      <v-card-title> Lista de Productoras/Empresas </v-card-title>
      <v-card-text class="pa-0 pa-sm-4">
        <div class="px-2">
          <v-row align="center" dense class="mt-n4 mb-2">
            <v-col cols="12" sm="5" md="6">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                clearable
                dense
                outlined
                label="Buscar agrícola..."
                v-model="search"
                hide-details
                class="white rounded-lg"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="7" md="6" class="text-end d-flex justify-end align-center" :class="{ 'd-none': $vuetify.breakpoint.xsOnly }">
              <v-btn color="primary" @click="showAddFarmModal = true" rounded small elevation="0" class="mr-2">
                <v-icon left size="18"> mdi-account-plus-outline </v-icon>
                Nueva
              </v-btn>
              
              <!-- Desktop Filter Menu -->
              <v-menu
                offset-y
                :close-on-click="false"
                :close-on-content-click="false"
                :nudge-bottom="10"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0">
                    <v-icon left size="18">mdi-filter</v-icon>
                    Filtros
                  </v-btn>
                </template>
                <v-card width="350px">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" class="px-0 py-0">
                          Distribuidor
                          <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12">
                          <v-autocomplete
                            label="Distribuidor"
                            background-color="white"
                            outlined
                            v-model="distributorSelected"
                            clearable
                            :items="distributors"
                            item-text="companyName"
                            dense
                            return-object
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row v-if="distributorSelected">
                        <v-col cols="12" class="px-0 py-0">
                          Zona
                          <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12">
                          <v-autocomplete
                            label="Selecciona zona"
                            :items="zones"
                            clearable
                            hide-details
                            hide-no-data
                            dense
                            outlined
                            v-model="zoneSelected"
                            return-object
                            item-text="name"
                            :search-input.sync="zoneSearch"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" @click="clearFilters" text>Restaurar</v-btn>
                    <v-btn color="primary" @click="applyFilter" rounded>Aplicar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>

          <!-- Mobile Action Buttons & Filter -->
          <v-row v-if="$vuetify.breakpoint.xsOnly" class="px-3 pb-3 mt-n4 mb-n2">
            <v-col class="pa-0 text-right">
              <!-- Filter Bottom Sheet for Mobile -->
              <v-dialog
                v-model="mobileFilterDialog"
                transition="dialog-bottom-transition"
                fullscreen
                hide-overlay
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0" class="mr-2">
                    <v-icon left size="18">mdi-filter</v-icon> Filtros
                  </v-btn>
                </template>
                <v-card class="d-flex flex-column h-100 rounded-0">
                  <v-toolbar color="primary" dark fixed-header elevation="0">
                    <v-toolbar-title>Filtros de Productoras</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="mobileFilterDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="pt-6 flex-grow-1 overflow-y-auto">
                    <span class="font-weight-bold">Distribuidor</span>
                    <v-divider class="my-2 mb-4"></v-divider>
                    <v-autocomplete
                      label="Distribuidor"
                      background-color="white"
                      outlined
                      v-model="distributorSelected"
                      clearable
                      :items="distributors"
                      item-text="companyName"
                      dense
                      return-object
                    ></v-autocomplete>

                    <template v-if="distributorSelected">
                      <span class="font-weight-bold mt-4 d-block">Zona</span>
                      <v-divider class="my-2 mb-4"></v-divider>
                      <v-autocomplete
                        label="Selecciona zona"
                        :items="zones"
                        clearable
                        hide-details
                        hide-no-data
                        dense
                        outlined
                        v-model="zoneSelected"
                        return-object
                        item-text="name"
                        :search-input.sync="zoneSearch"
                      ></v-autocomplete>
                    </template>
                  </v-card-text>
                  
                  <div class="sticky-footer white pa-4 elevation-10">
                    <v-row dense>
                      <v-col cols="6">
                        <v-btn color="warning" block text @click="clearFilters">Restaurar</v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn color="primary" block rounded @click="applyFilter(); mobileFilterDialog = false;">
                          Aplicar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          
          <!-- Mobile Floating Action Button (FAB) -->
          <v-btn
            v-if="$vuetify.breakpoint.xsOnly"
            color="primary"
            dark
            fab
            fixed
            bottom
            right
            style="bottom: 80px; right: 16px; z-index: 5;"
            @click="showAddFarmModal = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-row class="mt-n4">
            <v-col>
              <template v-if="$vuetify.breakpoint.xsOnly">
                <v-container class="pa-2 px-0 bg-app">
                  <v-row dense>
                    <v-col
                      cols="12"
                      v-for="item in farms"
                      :key="item._id"
                      class="mb-2"
                    >
                      <v-card elevation="1" class="rounded-xl pa-4">
                        <div class="d-flex justify-space-between align-start mb-2">
                          <div class="d-flex align-center">
                            <v-avatar color="primary" size="40" class="mr-3">
                              <span class="white--text text-subtitle-1 font-weight-bold">
                                <v-icon dark>mdi-home-silo</v-icon>
                              </span>
                            </v-avatar>
                            <div>
                              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-4 line-height-tight">
                                <span v-if="item.billingInformation">
                                  {{ item.billingInformation.companyName }}
                                </span>
                                <span v-else class="font-italic grey--text"> Sin nombre registrado </span>
                              </div>
                              <div class="text-caption grey--text text--darken-1">
                                <span v-if="item.billingInformation && item.billingInformation.rfc">
                                  RFC: {{ item.billingInformation.rfc }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <v-menu :rounded="true" offset-y left>
                            <template v-slot:activator="{ attrs, on }">
                              <v-btn icon v-bind="attrs" v-on="on" small color="grey darken-1" class="mt-n2 mr-n2">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="showUpdateModal(item)">
                                <v-list-item-title> Actualizar </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>

                        <v-divider class="my-2"></v-divider>

                        <v-row dense class="text-caption">
                          <v-col cols="6" class="py-1">
                            <div class="grey--text">Ubicación</div>
                            <div class="font-weight-medium text-truncate primary--text" @click="showAllAddress(item)">
                              <span v-if="item.address">
                                {{ item.address.city }}, {{ item.address.state }}
                              </span>
                              <span v-else class="grey--text"> No especificada </span>
                            </div>
                          </v-col>
                          <v-col cols="6" class="py-1">
                            <div class="grey--text">Estado</div>
                            <v-chip
                              small
                              :color="item.isExpire ? 'error' : 'success'"
                              :text-color="'white'"
                              class="font-weight-bold px-2"
                              style="height: 20px;"
                            >
                              <span v-if="item.isExpire"> Suspendido </span>
                              <span v-else> Activo </span>
                            </v-chip>
                          </v-col>
                          <v-col cols="6" class="py-1">
                            <div class="grey--text">Asesor / Toma muestras</div>
                            <div class="font-weight-medium text-truncate" v-if="item.sampler">
                              {{ item.sampler.name }} {{ item.sampler.lastName }}
                            </div>
                            <div class="font-weight-medium grey--text" v-else>
                              Sin información
                            </div>
                          </v-col>
                          <v-col cols="6" class="py-1">
                            <div class="grey--text">Zona</div>
                            <div class="font-weight-medium text-truncate" v-if="item.zone">
                              {{ item.zone.name }}
                            </div>
                            <div class="font-weight-medium grey--text" v-else>
                              Sin zona
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <v-data-table
                v-else
                width="100%"
                :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 350px)`"
                :headers="headers"
                :items="farms"
                fixed-header
                :items-per-page="10"
                class="elevation-1"
                no-data-text="No hay productoras disponibles"
                loading-text="Cargando productoras..."
                :page.sync="page"
                hide-default-footer
                :loading="fetchingData"
              >
                <template v-slot:item.billingInformation="{ item }">
                  <div class="d-flex align-center py-2">
                    <v-avatar color="primary" size="36" class="mr-3">
                      <span class="white--text text-caption font-weight-bold">
                        <v-icon small dark>mdi-home-silo</v-icon>
                      </span>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold grey--text text--darken-4 line-height-tight">
                        <span v-if="item.billingInformation">
                          {{ item.billingInformation.companyName }}
                        </span>
                        <span v-else class="font-italic grey--text"> Sin nombre registrado </span>
                      </div>
                      <div class="text-caption grey--text text--darken-1">
                        <span v-if="item.billingInformation && item.billingInformation.rfc">
                          RFC: {{ item.billingInformation.rfc }}
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:item.companyName="{ item }">
                  <span v-if="item.companyName">{{ item.companyName }}</span>
                  <span v-else class="grey--text text--darken-1">No especificado</span>
                </template>
                <template v-slot:item.email="{ item }">
                  <span v-if="item.email">{{ item.email }}</span>
                  <span v-else class="grey--text text--darken-1">No especificado</span>
                </template>
                <template v-slot:item.phone="{ item }">
                  <span v-if="item.phone">{{ item.phone }}</span>
                  <span v-else class="grey--text text--darken-1">No especificado</span>
                </template>
                <template v-slot:item.address="{ item }">
                  <div
                    v-if="item.address"
                    class="font-weight-medium primary--text pointer"
                    style="cursor: pointer;"
                    @click="showAllAddress(item)"
                  >
                    <v-icon small color="primary" class="mr-1">mdi-map-marker</v-icon>
                    {{ item.address.city }}, {{ item.address.state }}
                  </div>
                  <div v-else class="grey--text text--darken-1"> No especificada </div>
                </template>
                <template v-slot:item.sampler="{ item }">
                  <div class="d-flex align-center" v-if="item.sampler">
                    <v-avatar color="secondary" size="28" class="mr-2">
                      <span class="white--text" style="font-size: 0.7rem;">
                        {{ item.sampler.name ? item.sampler.name.charAt(0) : '' }}
                      </span>
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium text-caption">{{ item.sampler.name }} {{ item.sampler.lastName }}</div>
                      <div class="text-caption grey--text" style="font-size: 0.7rem !important;">{{ item.sampler.email }}</div>
                    </div>
                  </div>
                  <div v-else class="grey--text text--darken-1"> Sin información </div>
                </template>
                <template v-slot:item.zone="{ item }">
                  <v-chip v-if="item.zone" small color="grey lighten-3" text-color="grey darken-3" class="font-weight-medium">
                    {{ item.zone.name }}
                  </v-chip>
                  <span v-else class="grey--text text--darken-1"> Sin zona </span>
                </template>
                <template v-slot:item.isExpire="{ item }">
                  <v-chip
                    small
                    :color="item.isExpire ? 'error' : 'success'"
                    :text-color="'white'"
                    class="font-weight-bold px-3"
                  >
                    <span v-if="item.isExpire"> Suspendido </span>
                    <span v-else> Activo </span>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-menu :rounded="true" offset-y>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn class="ma-0" v-bind="attrs" v-on="on" icon small>
                        <v-icon color="grey darken-1"> mdi-dots-vertical </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="showUpdateModal(item)">
                        <v-list-item-title> Actualizar </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
              <v-pagination
                v-model="page"
                :length="numPages"
                total-visible="10"
                color="primary"
                class="mt-n2"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    <add-farm-modal
      v-model="showAddFarmModal"
      v-if="showAddFarmModal"
      @fetchData="fetchData"
    />
    <update-farm-modal
      v-model="showUpdateFarmModal"
      v-if="showUpdateFarmModal"
      @fetchData="fetchData"
    />
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapMutations } from "vuex";
//components
import AddFarmModal from "@/components/farms/modals/AddFarmModal.vue";
import UpdateFarmModal from "@/components/farms/modals/UpdateFarmModal.vue";
export default {
  components: {
    AddFarmModal,
    UpdateFarmModal,
  },
  data: () => ({
    showAddFarmModal: false,
    showUpdateFarmModal: false,
    page: 1,
    numPages: 0,
    fetchingData: false,
    search: null,

    farms: [],
    filter: null,
    zones: [],
    zoneSearch: null,
    zoneSelected: null,
    distributorSelected: null,
    distributors: [],
    mobileFilterDialog: false,
  }),
  computed: {
    headers() {
      return [
        { text: "Razón social", align: "start", sortable: false, value: "billingInformation" },
        { text: "Nombre", sortable: false, value: "companyName" },
        { text: "Correo", sortable: false, value: "email" },
        { text: "Teléfono", sortable: false, value: "phone" },
        { text: "Dirección", sortable: false, value: "address" },
        { text: "Usuario creación", sortable: false, value: "sampler" },
        { text: "Zona", sortable: false, value: "zone" },
        { text: "Estatus", sortable: false, value: "isExpire" },
        { text: "Acciones", sortable: false, value: "actions" },
      ];
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("organization", ["SET_FARM_TO_UPDATE"]),
    ...mapActions("organization", ["getFarms"]),
    ...mapActions("user", ["getDistributors"]),
    ...mapActions("zone", ["getZonesByDistributorPaged"]),
    showUpdateModal(organization) {
      this.SET_FARM_TO_UPDATE(organization);
      this.showUpdateFarmModal = true;
    },
    async clearFilters() {
      this.zoneSearch = null;
      this.zoneSelected = null;
      this.distributorSelected = null;
      this.zones = [];
      await this.fetchData();
    },
    async applyFilter() {
      this.filter = {
        zone: this.zoneSelected ? this.zoneSelected._id : null,
        distributor: this.distributorSelected
          ? this.distributorSelected._id
          : null,
      };
      await this.fetchData();
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let payload = {
          page: this.page,
          search: this.search,
          filters: this.filter,
        };
        let response = await this.getFarms(payload);
        if (!response) throw response;
        this.farms = response.famrs;
        this.numPages = response.pages;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar usuarios",
          timeout: 5000,
        });
      }
      this.fetchingData = false;
    },

    async fetchDistributors() {
      try {
        let response = await this.getDistributors();
        if (!response) throw response;
        this.distributors = response.distributors;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar distribuidores",
          timeout: 5000,
        });
      }
    },
  },
  async created() {
    await this.fetchData();
    await this.fetchDistributors();
  },
  watch: {
    async search() {
      this.page = 1;
      this.numPages = 1;
      await this.fetchData();
    },
    async page() {
      await this.fetchData();
    },
    async zoneSearch(value) {
      if (!value) return;
      try {
        let payload = {
          distributorId: this.distributorSelected
            ? this.distributorSelected._id
            : null,
          page: 1,
          search: value,
        };
        let response = await this.getZonesByDistributorPaged(payload);
        if (!response) throw response;
        this.zones = response.zones;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar zonas",
          timeout: 5000,
        });
      }
    },
    distributorSelected() {
      this.zones = [];
      this.zoneSelected = null;
    },
  },
};
</script>

<style scoped></style>
